<template>
  <div class="list-wrap" @click="listTap">
    <div class="list-box">
      <div class="list-imgwrap">
        <van-image class="list-img" :src="item.coverUrl" fit="cover" />
        <div
          class="list-tab"
          :class="{
            'list-tab-green': item.liveStatus == 1,
            'list-tab-white': item.liveStatus == 2
          }"
        >
          <van-image
            class="tab-icon"
            v-if="item.liveStatus == 1"
            :src="require('../../../../assets/play.png')"
            fit="cover"
          />
          <span class="tab-text">{{ item.statusText }}</span>
        </div>
      </div>
      <div class="list-main">
        <div class="list-title">{{ item.liveName }}</div>
        <div class="list-time">
          开始时间：{{ item.startTimeStr }} {{ item.startWeek }}
        </div>
        <div class="list-look" v-if="item.status != 1">
          {{ item.viewNumber }}次观看
        </div>
        <div class="list-btn">查看</div>
      </div>
    </div>
  </div>
</template>
<script>
import { saveRecord, saveUVRecord } from '@api/lishui/live'
export default {
  props: ['item'],
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      saveRecord(params).then(res => {})
      saveUVRecord(params).then(res => {})
    },
    listTap() {
      this.buriedPoint()
      this.$router.push({
        path: '/live/liveDetails',
        query: {
          id: this.item.id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.list-wrap {
  padding: 6px 15px;
  background: #fff;
  .list-box {
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 2px 10px 4px #eaeff6;
    position: relative;
    .list-imgwrap {
      width: 100%;
      height: 120px;
      border-radius: 4px;
      overflow: hidden;
      .list-img {
        width: 100%;
        height: 100%;
      }
      .list-tab {
        font-size: 12px;
        color: #fff;
        background: rgba(0, 0, 0, 0.5);
        padding: 4px 6px;
        border-radius: 2px;
        display: flex;
        align-items: center;
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 1;
        .tab-icon {
          width: 14px;
          margin-right: 4px;
        }
      }
      .list-tab-green {
        background: rgba(0, 184, 102, 0.7);
      }
      .list-tab-white {
        background: rgba(255, 255, 255, 0.5);
        color: #333;
      }
    }
    .list-main {
      padding: 13px 13px 20px;
      .list-title {
        font-size: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .list-time {
        color: #999;
        font-size: 12px;
        margin: 12px 0 0;
      }
      .list-look {
        color: #0070ff;
        font-size: 12px;
        margin-top: 12px;
      }
      .list-btn {
        border: 1px solid #0070ff;
        font-size: 12px;
        color: #0070ff;
        padding: 6px 20px;
        border-radius: 20px;
        position: absolute;
        right: 13px;
        bottom: 14px;
      }
    }
  }
}
</style>
